import React from 'react'
import { VirtualizedSelectOption, VirtualizedSelectOptionsType } from '../../Select/SelectVirtualized';
import { Merchant } from '../../../interfaces/Merchant';
import { CustomeStoreCompanyIdProps, useCustomeStore } from '../../../stores/CustomeStore';
import { UserModel } from '../../../app/modules/auth/models/UserModel';
import { currencyFormatter, customNumberFormat } from '../../../functions/general';
import moment from 'moment-timezone';
import useUser from '../../../hooks/User';
import WrapperCustomMulti from './WrapperCustomMulti';
import { usePipelineStore } from '../../../stores/PipelineStore';
import LabelTooltip from '../../General/LabelTooltip';

export interface VirtualizedSelectOptionMeeting extends VirtualizedSelectOption {
    dateMeet?: string
    meetingStatus?: string
    name?: string
}

export interface VirtualizedSelectOptionPipeline extends VirtualizedSelectOption {
    nominal: string | number
    dateCreated: string
    companyCurrency: "IDR" | "USD"
    companyCurrencyNeedRound: boolean
}

export interface VirtualizedSelectOptionMerchant extends VirtualizedSelectOption {
    name: string
    phone: string
    customFields: Record<string, string>
}

interface CustomSelectVirtualizedSelect extends VirtualizedSelectOption {
    name?: string
    nameCustomField?: string
    nameTemplate?: string
    nameMerchant?: string
    idCustomField?: string
    idTemplate?: string
    idMerchant?: string
    customFieldCompanyCode?: string
    idMerchantLink?: string
    nominal?: number
    dateCreated?: string
}

interface CustomSelectVirtualizedSelectType extends VirtualizedSelectOption {
    name?: string
    nameCustomField?: string
    nameTemplate?: string
    nameMerchant?: string
    idCustomField?: string
    idTemplate?: string
    idMerchant?: string
    customFieldCompanyCode?: string
    idMerchantLink?: string
    nominal?: number
    dateCreated?: string
}

interface CustomSelectMerchantOptionProps {
    merchants: Merchant[];
    option: VirtualizedSelectOptionsType;
    onClick?: () => void;
    user: UserModel;
    companyId: CustomeStoreCompanyIdProps;
}

interface CustomSelectMerchantOptionReqESBProps {
    user: UserModel;
    companyId: CustomeStoreCompanyIdProps;
    simpleMerchants: Merchant[];
    option: VirtualizedSelectOptionsType;
    onClick?: () => void;
}

interface CustomSelectSingleMerchantValueReqESBProps {
    user: UserModel;
    companyId: CustomeStoreCompanyIdProps;
    simpleMerchants: Merchant[];
    value: VirtualizedSelectOption;
    placeholder?: string;
}

interface CustomSelectSingleMerchantValueProps {
    merchants: Merchant[];
    value: VirtualizedSelectOption;
    placeholder?: string;
    user: UserModel;
    companyId: CustomeStoreCompanyIdProps;
}

interface CustomSelectMerchantLinkOptionProps {
    user: UserModel;
    companyId: CustomeStoreCompanyIdProps;
    option: VirtualizedSelectOptionsType;
    onClick?: () => void;
}

interface CustomSelectSingleMerchantLinkValueProps {
    user: UserModel;
    companyId: CustomeStoreCompanyIdProps;
    value: CustomSelectVirtualizedSelect;
    placeholder?: string;
}

interface CustomSelectMultiMeetingValueProps {
    selectedOption: VirtualizedSelectOptionMeeting[]
    handleClose: (v: VirtualizedSelectOptionMeeting) => void
}

interface CustomSelectMultiPipelineValueProps {
    selectedOption: VirtualizedSelectOptionPipeline[]
    handleClose: (v: VirtualizedSelectOptionPipeline) => void
}

interface CustomSelectMultiMerchantValueProps {
    selectedOption: VirtualizedSelectOptionMerchant[]
    handleClose: (v: VirtualizedSelectOptionMerchant) => void
    user: UserModel
    companyId: CustomeStoreCompanyIdProps
}

export const CustomSelectMerchantOption = ({ merchants, option, user, companyId }: CustomSelectMerchantOptionProps) => {
    var result = merchants.find((merchant: Merchant) => merchant.id === option.value);
    var labels = result?.labels?.map((label: any) => ({text: label.name, color: label.color})) || [];

    return (
        <div className="d-flex align-items-center px-3 h-100" style={{ cursor: 'pointer', background: option.value === 'chocolate' ? '#d9d9d9' : 'transparent', }}>
            <span className="align-middle"><b>{option?.label}</b> {user.data.company_id === companyId.maspionSquare && `/ ${result?.customFields['dea8766f-93ed-472a-92b8-7d94444609e0']}`}</span>
            {
                labels.length > 0 && (
                    <LabelTooltip data={labels}>
                        {labels}
                    </LabelTooltip>
                )
            }
        </div>
    );
}

export const CustomSelectSingleMerchantValueReqESB = ({ user, companyId, simpleMerchants, value, placeholder }: CustomSelectSingleMerchantValueReqESBProps) => {
    if (!value?.value) return <span>{placeholder}</span>
    var result = simpleMerchants.find((merchant: Merchant) => merchant.id === value.value);
    var customFieldValueCompanyCode = result?.customFieldCompanyCode ? result.customFieldCompanyCode : "-";

    return (
        user.data.company_id === companyId.esb ?
            <span className="align-middle"><b>{result?.name}</b> / {customFieldValueCompanyCode}</span>
            :
            <span className="align-middle">{result?.name}</span>
    );
}

export const CustomSelectMerchantOptionReqESB = ({ user, companyId, simpleMerchants, option, onClick }: CustomSelectMerchantOptionReqESBProps) => {
    var result = simpleMerchants.find((merchant: Merchant) => merchant.id === option.value);
    var customFieldValueCompanyCode = result?.customFieldCompanyCode ? result.customFieldCompanyCode : "-";

    return (
        <div className="d-flex align-items-center h-100 px-3" style={{ cursor: 'pointer', background: option.value === 'chocolate' ? '#d9d9d9' : 'transparent', }}>
            {
                user.data.company_id === companyId.esb ?
                    <span className="align-middle"><b>{result?.name}</b> / {customFieldValueCompanyCode}</span>
                    :
                    <span className="align-middle">{result?.name}</span>
            }
        </div>
    );
}

export const CustomSelectSingleMerchantValue = ({ merchants, value, placeholder, user, companyId }: CustomSelectSingleMerchantValueProps) => {
    if (!value?.value) return <span>{placeholder}</span>
    var result = merchants.find((merchant: Merchant) => merchant.id === value.value);
    var labels = result?.labels?.map((label: any) => ({text: label.name, color: label.color})) || [];

    return (
        <div className='d-flex align-items-center'>
            <span className="align-middle"><b>{result?.name}</b> / {result?.phone} {user.data.company_id === companyId.maspionSquare && `/ ${result!.customFields['dea8766f-93ed-472a-92b8-7d94444609e0']}`}</span>
{
                labels.length > 0 && (
                    <LabelTooltip data={labels}>
                        {labels}
                    </LabelTooltip>
                )
            }
        </div>
    );
}

export const CustomSelectMerchantLinkOption = ({ user, companyId, option, onClick }: CustomSelectMerchantLinkOptionProps) => {

    return (
        <div className="d-flex align-items-center h-100 px-3" style={{ cursor: 'pointer', background: option.value === 'chocolate' ? '#d9d9d9' : 'transparent', }}>
            {
                user.data.company_id === companyId.esb ?
                    <span className="align-middle">{option.nameTemplate} / {option.nameMerchant}</span>
                    :
                    <span className="align-middle">{option.nameTemplate} / {option.nameMerchant}</span>
            }
        </div>
    );
}

export const CustomSelectSingleMerchantLinkValue = ({ user, companyId, value, placeholder }: CustomSelectSingleMerchantLinkValueProps) => {
    if (!value?.value) return <span>{placeholder}</span>

    return (
        user.data.company_id === companyId.esb ?
            <span className="align-middle">{value.nameTemplate} / {value.nameMerchant}</span>
            :
            <span className="align-middle">{value.nameTemplate} / {value.nameMerchant}</span>
    );
}

export const CustomSelectPipelineOption = (props: any) => {
    const pipelineData = props.option;
    const { selectMultiPipeline } = usePipelineStore();
    if (!pipelineData?.name) return null;
    return (
        <div className="d-flex align-items-center px-3 h-100">
            <span className="align-middle"><b>{pipelineData.name}</b> / {pipelineData.nominal} / {moment(pipelineData.dateCreated).format("DD MMM YYYY")}</span>
        </div>
    );
}

export const CustomSelectPipelineSingleValue = (props: any) => {
    const { selectMultiPipeline } = usePipelineStore();
    if (!props.value?.value) return <span>{props.placeholder}</span>
    const pipelineData = props.value;
    if (!pipelineData?.name) return null;
    return (
        <div className="d-flex align-items-center px-3 h-100">
            <span className="align-middle"><b>{pipelineData.name}</b> / {pipelineData.nominal} / {moment(pipelineData.dateCreated).format("DD MMM YYYY")}</span>
        </div>
    );
}

export const CustomSelectMeetingOption = (props: any) => {
    const meetingData = props.option;
    if (!meetingData?.name) return null;
    const splitData = meetingData?.id?.split('-');
    const subString = splitData?.[splitData.length - 1].substring(7, splitData?.[splitData.length - 1].length);
    return (
        <div className="d-flex align-items-center px-3 h-100">
            <span className="align-middle"><b>{meetingData.name}</b> / {moment(meetingData.dateMeet).format("DD MMM YYYY")} / {meetingData.meetingStatus} / {subString}</span>
        </div>
    );
}

export const CustomSelectPipelineMultiValue = ({ selectedOption, handleClose }: CustomSelectMultiPipelineValueProps) => {
    return (
        <>
            {Array.isArray(selectedOption) &&
                selectedOption.map((v) => {
                    return (
                        <WrapperCustomMulti
                            key={v.value}
                            v={v}
                            handleClose={handleClose}
                        >
                            {`${v.label}`}
                        </WrapperCustomMulti>
                    )
                })}
        </>
    )
}

export const CustomSelectMeetingMultipleValue = ({ selectedOption, handleClose }: CustomSelectMultiMeetingValueProps) => {
    return (
        <>
            {Array.isArray(selectedOption) &&
                selectedOption.map((v) => {
                    return (
                        <WrapperCustomMulti
                            key={v.value}
                            v={v}
                            handleClose={handleClose}
                        >
                            {`${v.label}`}
                        </WrapperCustomMulti>
                    )
                })}
        </>
    )
}

export const CustomSelectMerchantOptionMultiValue = ({ selectedOption, handleClose, user, companyId }: CustomSelectMultiMerchantValueProps) => {
    return (
        <>
            {Array.isArray(selectedOption) &&
                selectedOption.map((v) => {
                    return (
                        <WrapperCustomMulti
                            key={v.value}
                            v={v}
                            handleClose={handleClose}
                        >
                            <span className="align-middle">{v.label}</span>
                        </WrapperCustomMulti>
                    )
                })}
        </>
    );
}

export const CustomSelectPipelineLogLead = (props: any) => {
    const pipelineData = props.option;
    const { selectMultiPipeline } = usePipelineStore();
    if (!pipelineData?.merchant_name) return null;
    return (
        <div className="d-flex align-items-center px-3 h-100">
            <span className="align-middle"><b>{pipelineData.merchant_name} / {pipelineData.owner_name} / {moment(pipelineData.date_start).format("DD MMM YYYY")}</b> / {pipelineData.nominal}</span>
        </div>
    )
}